module.exports = __webpack_public_path__ + "img/labz-mad-at-architect.4ceb2e41.png";